// extracted by mini-css-extract-plugin
export var errorIcon = "_no-1";
export var nameLogo = "_no-0";